export const contact = {
	contact: {
		title: "Contact",
		description: "Feel free to reach out.",
		emailMe: "Email Me",
		socials: "Social Media",
	},
} as const;
